import * as XLSX from "xlsx";
import { t, allTranslations } from "@/lib/i18n";

// columns: [{ key, label, type: "text" | "number" | "int", width }]
export function downloadTemplate(columns, example, filename, sheetName) {
  const ws = XLSX.utils.aoa_to_sheet([columns.map((c) => t(c.label)), example]);
  ws["!cols"] = columns.map((c) => ({ wch: c.width || Math.max(14, t(c.label).length + 4) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, t(sheetName));
  XLSX.writeFile(wb, filename);
}

const norm = (s) => String(s ?? "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");

function toValue(v, type) {
  if (type === "number") return parseFloat(String(v ?? "").replace(",", ".")) || 0;
  if (type === "int") return parseInt(String(v ?? ""), 10) || 0;
  return String(v ?? "").trim();
}

// Reads .xlsx/.xls/.csv (comma or semicolon); headers matched by Italian label or field key
export async function parseSheet(file, columns) {
  let wb;
  if (/\.csv$/i.test(file.name)) {
    const text = await file.text();
    const first = text.split(/\r?\n/)[0] || "";
    const FS = (first.match(/;/g) || []).length > (first.match(/,/g) || []).length ? ";" : ",";
    wb = XLSX.read(text, { type: "string", FS });
  } else {
    wb = XLSX.read(await file.arrayBuffer(), { type: "array" });
  }
  const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, defval: "", raw: true });
  if (rows.length < 2) return [];
  const idx = rows[0].map((h) => columns.find((c) => norm(c.key) === norm(h) || allTranslations(c.label).some((l) => norm(l) === norm(h))));
  return rows.slice(1).filter((r) => r.some((v) => String(v).trim())).map((r) => {
    const o = {};
    columns.forEach((c) => { o[c.key] = toValue("", c.type); });
    idx.forEach((c, i) => { if (c) o[c.key] = toValue(r[i], c.type); });
    return o;
  });
}
